
export function validatePhone(rule, value, callback) {
    const reg = /^1\d{10}$/
    if(reg.test(value) || value == null || value == "") {
        callback();
    } else {
        callback(new Error('电话格式错误'));
    }
}

export function validateQQ(rule, value, callback) {
    const reg = /^[1-9]\d{4,10}$/
    if(reg.test(value) || value == null || value == "") {
        callback();
    } else {
        callback(new Error('QQ格式错误'));
    }
}

export function validateEmail (rule, value, callback) {
    const reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
    if(reg.test(value) || value == null || value == "") {
        callback();
    } else {
        callback(new Error('邮箱格式错误'));
    }
}

export function validateSort (rule, value, callback) {
    const reg = /^\d{1,3}$/
    if(reg.test(value) || value == null || value == "") {
        callback();
    } else {
        callback(new Error('最多输入3位数字'));
    }
}

export function validatePrice (rule, value, callback) {
  const reg = /^(?:0\.\d{0,1}[0-9]|(?!0)\d{1,6}(?:\.\d{0,1}[0-9])?)$/;
  // if(value == '0.0' || value == '0.00') {
  //   callback(new Error('只允许输入小于1000000的正数且小数点后不超过2位'));
  // }
  if(reg.test(value) || value == null || value == "" || value=="0" || value=="0.0" || value=="0.00") {
    if(value=="0" || value=="0.0" || value=="0.00") {
      callback(new Error('原价不能为0'));
    } else {
      callback();
    }
  } else {
    callback(new Error('只允许输入小于1000000的正数且小数点后不超过2位'));
  }
}
export function validatePreferentialPrice (rule, value, callback) {
  const reg = /^(?:0\.\d{0,1}[0-9]|(?!0)\d{1,6}(?:\.\d{0,1}[0-9])?)$/;
  // if(value == '0.0' || value == '0.00') {
  //   callback(new Error('只允许输入小于1000000的正数且小数点后不超过2位'));
  // }
  if(reg.test(value) || value == null || value == "" || value=="0" || value=="0.0" || value=="0.00") {
    callback();
  } else {
    callback(new Error('只允许输入小于1000000的正数且小数点后不超过2位'));
  }
}

export function validateNumber (rule, value, callback) {
  const reg = /^\d{1,5}$/
  if(reg.test(value) || value == "") {
    callback();
  } else {
    callback(new Error('只允许输入1-99999的正整数'));
  }
}

export function validateClassTime (rule, value, callback) {
  const reg = /^\d{1,4}$/
  if(reg.test(value) || value == null || value == "") {
    callback();
  } else {
    callback(new Error('只允许输入1-9999的正整数'));
  }
}

export function validatePassword (rule, value, callback) {
  const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
  if(reg.test(value) || value == "") {
    callback();
  } else {
    callback(new Error('长度6-16，必须包含英文和数字'));
  }
}

export function validateOrgCode (rule, value, callback) {
  const reg = /^[0-9A-Za-z]{1,20}$/
  if(reg.test(value) || value == "") {
    callback();
  } else {
    callback(new Error('只允许输入1-20位数字或字母组合'));
  }
}

export function validateUserName (rule, value, callback) {
  const reg = /^[A-Za-z_0-9_]{6,20}$/
  if(reg.test(value) || value == "") {
    callback();
  } else {
    callback(new Error('只允许输入6-20位字母、数字、下划线'));
  }
}

export function validateValidity (rule, value, callback) {
  const reg = /^[1-9]\d*$/
  if(reg.test(value) && value <10000 || value=="" || value==-1) {
    callback();
  } else {
    callback(new Error('只允许输入小于10000的正整数'));
  }
}

export default {
    validatePhone,
    validateQQ,
    validateEmail,
    validateSort,
    validatePrice,
    validateNumber,
    validatePassword,
    validateOrgCode,
    validateClassTime,
    validateUserName,
    validatePreferentialPrice
}